import { _USER } from "@/state";
import { ziggyGetRoute as getRoute } from '@/router/ziggyGetRoute';
import store from "@/store";

export default (to, from, next) => {
	if (!!_USER().isAuthenticated()) {
		if (!_USER().emailIsVerified() && ['verificationNotice', 'logout', 'platformPage'].indexOf(to.name) === -1) {
			next(getRoute('verification.notice'))
			return
		}
	}
}